import { render } from "./labelmanageadd.vue?vue&type=template&id=72d2dd30"
import script from "./labelmanageadd.vue?vue&type=script&lang=js"
export * from "./labelmanageadd.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__